import SearchBlock from '@insurancemenu/imenu-components-lib/dist/components/SearchBlock';
import { Button, colors, IMForm } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';
import { breakpointsMQ4 } from '@insurancemenu/imenu-components-lib/dist/utils';

export const IMFormStyled = styled(IMForm)`
  max-width: none;
  width: 100%;
  gap: 2rem;
  background-color: ${colors.neutral.white};
  border-radius: 10px;
  box-sizing: border-box;
  padding: 4rem 10rem 8rem;
  margin: 0;

  ${breakpointsMQ4.lg.down} {
    padding: 4rem 4rem 8rem;
  }
`;

export const ToggleDetailsButtonStyled = styled(Button)`
  padding-left: 0;
  margin: 2rem 0;
  width: 100%;
  justify-content: flex-start;
  text-align: left;
`;

export const SearchBlockStyled = styled(SearchBlock)`
  width: 100%;
`;
